import { auth } from './auth';
import { persisted, useStore } from './store';

/** Games a visitor without an account may start on their own (bot, pass & play, four players offline). */
export const FREE_GAMES = 3;
const used = persisted<{ used: number }>('ic.guestGames', { used: 0 });

export const isGuest = () => { const u = auth.get().user; return !u || u.guest; };

/** Count one started game for a guest. Joining a game by invite link is always free. */
export function countGuestGame() {
  if (isGuest()) used.set({ used: used.get().used + 1 });
}

export function useGuestQuota() {
  const a = useStore(auth);
  const u = useStore(used);
  const guest = !a.user || a.user.guest;
  return { guest, left: guest ? Math.max(0, FREE_GAMES - u.used) : Infinity };
}
